export class ApiError extends Error {
  constructor(status, message, data = null) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.data = data;
  }
}

export async function requestJson(url, options = {}) {
  const {
    auth,
    fetchImpl = globalThis.fetch,
    body,
    headers: suppliedHeaders = {},
    ...init
  } = options;
  const headers = { Accept: "application/json", ...suppliedHeaders };
  if (auth) {
    const token = await auth.getToken();
    if (token) headers.Authorization = `Bearer ${token}`;
  }
  if (body !== undefined) headers["Content-Type"] = "application/json";

  const response = await fetchImpl(url, {
    ...init,
    headers,
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const type = response.headers.get("Content-Type") || "";
  const data = type.includes("application/json") ? await response.json() : null;
  if (!response.ok) {
    throw new ApiError(response.status, data?.error || `Request failed (${response.status})`, data);
  }
  return data;
}
